// src/client/pages/RegisterClient.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthClient } from '../../core/context/AuthClientContext';
import api from '../../core/api';

const RegisterClient = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
  });
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const { login } = useAuthClient();

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    try {
      // 🔑 Clé client
      const clientKey = localStorage.getItem('selectedClient') || 'le_resto_local';

      // 📤 Envoi de la requête
      const res = await api.post('/api/users/register', formData, {
        headers: { 'x-client-key': clientKey },
      });

      // Si l’API renvoie directement un token + user
      if (res.data?.token && res.data?.user) {
        login(res.data.token, res.data.user);
        setMessage('✅ Inscription réussie ! Redirection...');
        setTimeout(() => navigate('/account'), 1200);
      } else {
        // Si l’API ne renvoie qu’un message
        setMessage('✅ Inscription réussie ! Vous pouvez vous connecter.');
        setTimeout(() => navigate('/client-login'), 1200);
      }
    } catch (err) {
      console.error('❌ Erreur inscription client :', err.response?.data || err.message);
      setMessage('❌ Erreur : ' + (err.response?.data?.message || 'Erreur inconnue.'));
    }
  };

  return (
    <div className="register-page-container">
      <div className="theme6-modal">
        <h2>Créer un compte</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Nom"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Adresse email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="tel"
            name="phone"
            placeholder="Téléphone"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Mot de passe"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <button type="submit">S'inscrire</button>
        </form>
        {message && <p className="auth-message">{message}</p>}
      </div>
    </div>
  );
};

export default RegisterClient;
